import React from "react";
import { buildWordCounts, normalizeWord, splitTokens } from "./textTransforms";

export const renderVocabularyDiffText = (processText, vocabularyText) => {
  const processCounts = buildWordCounts(processText || "");
  return splitTokens(vocabularyText).map((token, index) => {
    const normalized = normalizeWord(token);
    if (!normalized) {
      return <React.Fragment key={`vocab-${normalized}-${index}`}>{token}</React.Fragment>;
    }
    const available = processCounts.get(normalized) || 0;
    if (available > 0) {
      processCounts.set(normalized, available - 1);
      return <React.Fragment key={`vocab-${normalized}-${index}`}>{token}</React.Fragment>;
    }
    return (
      <span key={`vocab-${normalized}-${index}`} className="highlight-vocabulary-yellow">
        {token}
      </span>
    );
  });
};

export const renderProcessDiffText = (originalText, processText) => {
  const originalCounts = buildWordCounts(originalText || "");
  return splitTokens(processText).map((token, index) => {
    const normalized = normalizeWord(token);
    if (!normalized) {
      return <React.Fragment key={`process-${normalized}-${index}`}>{token}</React.Fragment>;
    }
    const available = originalCounts.get(normalized) || 0;
    if (available > 0) {
      originalCounts.set(normalized, available - 1);
      return <React.Fragment key={`process-${normalized}-${index}`}>{token}</React.Fragment>;
    }
    return (
      <span key={`process-${normalized}-${index}`} className="highlight-process-red">
        {token}
      </span>
    );
  });
};

export const renderComparisonText = (originalText, _processText, finalText) => {
  const originalCounts = buildWordCounts(originalText || "");

  return splitTokens(finalText).map((token, index) => {
    const normalized = normalizeWord(token);
    if (!normalized) {
      return <React.Fragment key={`final-${normalized}-${index}`}>{token}</React.Fragment>;
    }
    const originalAvailable = originalCounts.get(normalized) || 0;
    const fromOriginal = originalAvailable > 0;

    if (fromOriginal) {
      originalCounts.set(normalized, originalAvailable - 1);
      return <React.Fragment key={`final-${normalized}-${index}`}>{token}</React.Fragment>;
    }

    return (
      <span key={`final-${normalized}-${index}`} className="highlight-final-green">
        {token}
      </span>
    );
  });
};
